import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useBrand } from "@/context/BrandContext";
import { useAuth } from "@/context/AuthContext";
import { getLang, t } from "@/lib/i18n";

export function useCourse() {
  const { slug } = useBrand();
  return useQuery({
    queryKey: ["course", slug],
    queryFn: async () => (await api.get("/course", { params: { edition: slug } })).data,
    enabled: !!slug,
  });
}

export function useProgress() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["progress", user && user.id],
    queryFn: async () => (await api.get("/progress")).data,
    enabled: !!user,
    staleTime: 0,
  });
}

export function currentTierData(progress) {
  if (!progress) return null;
  return progress.tiers.find((t) => t.tier === progress.current_tier);
}

export const SHOW_READINESS = false;

export const CREDENTIAL_NOTE_EN = "This is a learning credential. It is not an engineering licence, a safety certificate, or permission to operate or change anything in a plant.";
export const credentialNote = () => (getLang() === "fr" ? t("credential-note") : CREDENTIAL_NOTE_EN);

export const TIER_COPY = {
  foundation: { label: "Foundation", blurb: "Core concepts, recall and first applications.", mark: "I" },
  practitioner: { label: "Practitioner", blurb: "Same lessons, more applied questions and trade-offs.", mark: "II" },
  strategist: { label: "Strategist", blurb: "Hardest scenarios, plus the Line 3 capstone.", mark: "III" },
};

export const STATUS_LABEL = {
  not_started: "Not started",
  in_progress: "In progress",
  repeat_course: "Repeat course",
  capstone_pending: "Capstone pending",
  certified: "Certified",
  skipped: "Skipped",
  locked: "Locked",
};
